import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { translations } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import PixelField from "@/components/PixelField";
import AdminPage from "@/components/AdminPage";
import HeaderNav from "@/components/HeaderNav";
import HeroSection from "@/components/HeroSection";
import Marquee from "@/components/Marquee";
import PortfolioGrid from "@/components/PortfolioGrid";
import TestimonialsSection from "@/components/TestimonialsSection";
import FaqSection from "@/components/FaqSection";
import BlogTeaser from "@/components/BlogTeaser";
import BlogList from "@/components/BlogList";
import BlogArticle from "@/components/BlogArticle";
import ServicesBento from "@/components/ServicesBento";
import PriceOnRequestBanner from "@/components/PriceOnRequestBanner";
import ProcessTimeline from "@/components/ProcessTimeline";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

function App() {
    const path = window.location.pathname;
    const isAdmin = path === "/admin";
    const blogMatch = path.match(/^\/blog\/?([a-z0-9-]+)?\/?$/);
    const [lang, setLang] = useState("sk");
    const t = translations[lang];
    const lenisRef = useRef(null);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        lenisRef.current = lenis;
        let rafId;
        const loop = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    useEffect(() => {
        if (isAdmin) return;
        try {
            let vid = localStorage.getItem("wr_vid");
            if (!vid) {
                vid = crypto.randomUUID();
                localStorage.setItem("wr_vid", vid);
            }
            const params = new URLSearchParams(window.location.search);
            const src = params.get("klient") || params.get("utm_source") || document.referrer || "";
            fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ vid, path: window.location.pathname, ref: src }),
            }).catch(() => {});
        } catch {}
    }, [isAdmin]);

    const scrollTo = (id) => {
        lenisRef.current?.scrollTo(id, { offset: -72, duration: 1.5 });
    };

    if (isAdmin) {
        return (
            <>
                <AdminPage />
                <Toaster theme="dark" position="bottom-right" />
            </>
        );
    }

    if (blogMatch) {
        const goHomeSection = (id) => {
            window.location.href = `/${id}`;
        };
        return (
            <div className="min-h-screen bg-ink text-ivory font-sans">
                <PixelField />
                <HeaderNav t={t} lang={lang} setLang={setLang} onNavigate={goHomeSection} />
                {blogMatch[1] ? (
                    <BlogArticle t={t} lang={lang} slug={blogMatch[1]} />
                ) : (
                    <BlogList t={t} lang={lang} />
                )}
                <Footer t={t} onNavigate={goHomeSection} />
                <Toaster theme="dark" position="bottom-right" />
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-ink text-ivory font-sans">
            <PixelField />
            <HeaderNav t={t} lang={lang} setLang={setLang} onNavigate={scrollTo} />
            <main className="relative z-10">
                <HeroSection t={t} onNavigate={scrollTo} />
                <Marquee items={t.marquee} />
                <PortfolioGrid t={t} lang={lang} />
                <TestimonialsSection t={t} />
                <ServicesBento t={t} />
                <PriceOnRequestBanner t={t} onNavigate={scrollTo} />
                <ProcessTimeline t={t} />
                <BlogTeaser t={t} lang={lang} />
                <FaqSection t={t} />
                <ContactSection t={t} />
            </main>
            <Footer t={t} onNavigate={scrollTo} />
            <Toaster theme="dark" position="bottom-right" />
        </div>
    );
}

export default App;
